// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet polis-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto } from '../model/collectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto.ts';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails.ts';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails.ts';

import type { PolisGetPolissenParams } from '../model/polisGetPolissenParams.ts';

import type { PolisGetTerugvalParams } from '../model/polisGetTerugvalParams.ts';

import type { PolisGetWagenparkcontractParams } from '../model/polisGetWagenparkcontractParams.ts';

import type { Result1OfAanvragenPolissenBerekenTerugvalDto } from '../model/result1OfAanvragenPolissenBerekenTerugvalDto.ts';

import type { Result1OfAanvragenPolissenGetPolisDetailsResponseDto } from '../model/result1OfAanvragenPolissenGetPolisDetailsResponseDto.ts';

import type { Result1OfAanvragenPolissenGetWagenparkcontractafsprakenDto } from '../model/result1OfAanvragenPolissenGetWagenparkcontractafsprakenDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Haalt de polissen op van een relatie
 */
export const polisGetPolissen = (
  params?: MaybeRefOrGetter<PolisGetPolissenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfAanvragenPolissenGetPakketPolissenByRelatiePakketPolisDto>(
    { url: `/api/v2/polissen`, method: 'GET', params, signal },
    options,
  );
};

export const getPolisGetPolissenQueryKey = (params?: MaybeRefOrGetter<PolisGetPolissenParams>) => {
  return ['api', 'v2', 'polissen', ...(params ? [params] : [])] as const;
};

export const getPolisGetPolissenQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetPolissen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<PolisGetPolissenParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetPolissen>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetPolissenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetPolissen>>> = ({ signal }) =>
    polisGetPolissen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof polisGetPolissen>>,
    TError,
    TData
  >;
};

export type PolisGetPolissenQueryResult = NonNullable<Awaited<ReturnType<typeof polisGetPolissen>>>;
export type PolisGetPolissenQueryError = ErrorType<void>;

/**
 * @summary Haalt de polissen op van een relatie
 */

export function usePolisGetPolissen<
  TData = Awaited<ReturnType<typeof polisGetPolissen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<PolisGetPolissenParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetPolissen>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetPolissenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Haal de details van een individuele polis op
 */
export const polisGetPolisDetails = (
  polisnummer: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummer = toValue(polisnummer);

  return customInstance<Result1OfAanvragenPolissenGetPolisDetailsResponseDto>(
    { url: `/api/v2/polissen/${polisnummer}/details`, method: 'GET', signal },
    options,
  );
};

export const getPolisGetPolisDetailsQueryKey = (
  polisnummer: MaybeRefOrGetter<string | undefined | null>,
) => {
  return ['api', 'v2', 'polissen', polisnummer, 'details'] as const;
};

export const getPolisGetPolisDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetPolisDetails>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  polisnummer: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetPolisDetailsQueryKey(polisnummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetPolisDetails>>> = ({ signal }) =>
    polisGetPolisDetails(polisnummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(polisnummer) !== null && toValue(polisnummer) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>;
};

export type PolisGetPolisDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisGetPolisDetails>>
>;
export type PolisGetPolisDetailsQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Haal de details van een individuele polis op
 */

export function usePolisGetPolisDetails<
  TData = Awaited<ReturnType<typeof polisGetPolisDetails>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  polisnummer: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisDetails>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetPolisDetailsQueryOptions(polisnummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Haalt de samenvatting van een wagenparkcontract op basis van contractnummer en relatienummer op
 */
export const polisGetWagenparkcontract = (
  contractnummer: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<PolisGetWagenparkcontractParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  contractnummer = toValue(contractnummer);
  params = toValue(params);

  return customInstance<Result1OfAanvragenPolissenGetWagenparkcontractafsprakenDto>(
    { url: `/api/v2/polissen/${contractnummer}/wagenparkcontract`, method: 'GET', params, signal },
    options,
  );
};

export const getPolisGetWagenparkcontractQueryKey = (
  contractnummer: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<PolisGetWagenparkcontractParams>,
) => {
  return [
    'api',
    'v2',
    'polissen',
    contractnummer,
    'wagenparkcontract',
    ...(params ? [params] : []),
  ] as const;
};

export const getPolisGetWagenparkcontractQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetWagenparkcontract>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  contractnummer: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<PolisGetWagenparkcontractParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetWagenparkcontract>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetWagenparkcontractQueryKey(contractnummer, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetWagenparkcontract>>> = ({
    signal,
  }) => polisGetWagenparkcontract(contractnummer, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(contractnummer) !== null && toValue(contractnummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisGetWagenparkcontract>>, TError, TData>;
};

export type PolisGetWagenparkcontractQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisGetWagenparkcontract>>
>;
export type PolisGetWagenparkcontractQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Haalt de samenvatting van een wagenparkcontract op basis van contractnummer en relatienummer op
 */

export function usePolisGetWagenparkcontract<
  TData = Awaited<ReturnType<typeof polisGetWagenparkcontract>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  contractnummer: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<PolisGetWagenparkcontractParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisGetWagenparkcontract>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetWagenparkcontractQueryOptions(contractnummer, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
 * @summary Genereert het polisblad van een wagenparkcontract als PDF
 */
export const polisGetPolisblad = (
  contractnummer: MaybeRefOrGetter<number | undefined | null>,
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  contractnummer = toValue(contractnummer);
  relatienummer = toValue(relatienummer);

  return customInstance<unknown>(
    { url: `/api/v2/polissen/${contractnummer}/${relatienummer}/polisblad`, method: 'GET', signal },
    options,
  );
};

export const getPolisGetPolisbladQueryKey = (
  contractnummer: MaybeRefOrGetter<number | undefined | null>,
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v2', 'polissen', contractnummer, relatienummer, 'polisblad'] as const;
};

export const getPolisGetPolisbladQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetPolisblad>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  contractnummer: MaybeRefOrGetter<number | undefined | null>,
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisblad>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetPolisbladQueryKey(contractnummer, relatienummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetPolisblad>>> = ({ signal }) =>
    polisGetPolisblad(contractnummer, relatienummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () =>
        toValue(contractnummer) !== null &&
        toValue(contractnummer) !== undefined &&
        toValue(relatienummer) !== null &&
        toValue(relatienummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisblad>>, TError, TData>;
};

export type PolisGetPolisbladQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisGetPolisblad>>
>;
export type PolisGetPolisbladQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Genereert het polisblad van een wagenparkcontract als PDF
 */

export function usePolisGetPolisblad<
  TData = Awaited<ReturnType<typeof polisGetPolisblad>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  contractnummer: MaybeRefOrGetter<number | undefined | null>,
  relatienummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetPolisblad>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetPolisbladQueryOptions(contractnummer, relatienummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Polis.PolisInzien</li></ul>
 * @summary Bereken de bonus-malus-terugval van een subpolis
 */
export const polisGetTerugval = (
  polisnummer: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<PolisGetTerugvalParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummer = toValue(polisnummer);
  params = toValue(params);

  return customInstance<Result1OfAanvragenPolissenBerekenTerugvalDto>(
    { url: `/api/v2/polissen/${polisnummer}/terugval`, method: 'GET', params, signal },
    options,
  );
};

export const getPolisGetTerugvalQueryKey = (
  polisnummer: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<PolisGetTerugvalParams>,
) => {
  return ['api', 'v2', 'polissen', polisnummer, 'terugval', ...(params ? [params] : [])] as const;
};

export const getPolisGetTerugvalQueryOptions = <
  TData = Awaited<ReturnType<typeof polisGetTerugval>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  polisnummer: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<PolisGetTerugvalParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetTerugval>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisGetTerugvalQueryKey(polisnummer, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisGetTerugval>>> = ({ signal }) =>
    polisGetTerugval(polisnummer, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(polisnummer) !== null && toValue(polisnummer) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisGetTerugval>>, TError, TData>;
};

export type PolisGetTerugvalQueryResult = NonNullable<Awaited<ReturnType<typeof polisGetTerugval>>>;
export type PolisGetTerugvalQueryError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails | void
>;

/**
 * @summary Bereken de bonus-malus-terugval van een subpolis
 */

export function usePolisGetTerugval<
  TData = Awaited<ReturnType<typeof polisGetTerugval>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  polisnummer: MaybeRefOrGetter<string | undefined | null>,
  params?: MaybeRefOrGetter<PolisGetTerugvalParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof polisGetTerugval>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPolisGetTerugvalQueryOptions(polisnummer, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
